if(!customElements.get('drawer-window')) {
  class DrawerWindow extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.js-drawer-close');
    }

    connectedCallback() {
      if(!this.button) return;

      this.button.addEventListener('click', event => {
        event.preventDefault();
        
        this.parentElement.removeAttribute('open');
        this.parentElement.querySelector('summary').setAttribute('aria-expanded', false);
        this.classList.remove('is-open');
      });
    }
  }

  customElements.define('drawer-window', DrawerWindow);
}
